import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from "@/components/ui/navigation-menu";
import { apiBase } from "@/utils/urls";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

interface CompanyItem {
  id: number;
  name: string;
}

const Navigation = () => {
  const [companies, setCompanies] = useState<CompanyItem[]>([]);

  useEffect(() => {
    (async () => {
      const res = await fetch(apiBase + `/api/companies-list`);
      const data = (await res.json()) as CompanyItem[];
      setCompanies(data);
    })();
  }, []);

  return (
    <div className="absolute left-6 top-6 z-11">
      <NavigationMenu>
        <NavigationMenuList>
          {companies.length > 0 && (
            <NavigationMenuItem>
              <NavigationMenuTrigger>Companies</NavigationMenuTrigger>
              <NavigationMenuContent className="flex flex-col">
                {companies.map(({ id, name }) => (
                  <Link to={`/company/${id}`}>
                    <NavigationMenuLink className={navigationMenuTriggerStyle()}>
                      {name}
                    </NavigationMenuLink>
                  </Link>
                ))}
              </NavigationMenuContent>
            </NavigationMenuItem>
          )}
          <NavigationMenuItem>
            <Link to="/vacancies">
              <NavigationMenuLink className={navigationMenuTriggerStyle()}>
                Vacancies
              </NavigationMenuLink>
            </Link>
          </NavigationMenuItem>
          <NavigationMenuItem>
            <Link to="/profile">
              <NavigationMenuLink className={navigationMenuTriggerStyle()}>
                My Profile
              </NavigationMenuLink>
            </Link>
          </NavigationMenuItem>
        </NavigationMenuList>
      </NavigationMenu>
    </div>
  );
};

export default Navigation;
